@if (incorpForm) {
<div fxLayoutAlign="start" class="page gray-font-color font-family bodyBackground incorporation">
  <form [formGroup]="incorpForm">
    <div class="header-navigation-back">
      <mat-icon (click)="goBack()" data-test="back-arrow-icon">arrow_back</mat-icon>
      <span class="title">Incorporation / WSIB</span>
      <button mat-button [disabled]="loading" [class.save-disabled]="loading" class="header-action-button"
        (click)="onSubmit()" data-test="save-button">
        Save
      </button>
    </div>
    @if (errorMessage) {
    <mat-error class="error padding-left-md">
      {{ errorMessage }}
    </mat-error>
    }
    <div class="form-field">
      <div class="description">If you are an Owner Operator, please enter the details below</div>

      <!-- Incorporation Card -->
      <div class="section-card">
        <div class="section-header">
          <p>Incorporation</p>
        </div>
        <div class="card-content">
          <div>
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Business Number (9 Digits)</mat-label>
              <input matInput formControlName="incorporationNumber" required data-test="incorporation-number" />
              @if (incorporationNumber?.touched && incorporationNumber?.invalid) {
              <mat-error>
                {{ getIncorporationNumberErrorMessage() }}
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>GST / HST Number</mat-label>
              <input matInput formControlName="craNumber" data-test="cra-number" />
              @if (craNumber?.touched && craNumber?.invalid) {
              <mat-error>
                {{ getCRANumberErrorMessage() }}
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Corporation Name</mat-label>
              <input matInput formControlName="incorporationName" required data-test="incorporation-name" />
              @if (incorporationName?.touched && incorporationName?.invalid) {
              <mat-error>
                {{ getIncorporationNameErrorMessage() }}
              </mat-error>
              }
            </mat-form-field>
          </div>
          <div>
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Corporation Address</mat-label>
              <input matInput formControlName="incorporationAddress" data-test="incorporation-address" required />
              @if (incorporationAddress?.touched && incorporationAddress?.invalid) {
              <mat-error>
                {{ getIncorporationAddressErrorMessage() }}
              </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- WSIB Card -->
      <div class="section-card">
        <div class="section-header">
          <p>WSIB</p>
        </div>
        <div class="card-content">
          <div class="field-row">
            <div>
              <span class="field-header">Do you have a WSIB account?</span>
            </div>
            <div>
              <mat-radio-group formControlName="haveWorkplaceSafetyAccount" #wsibAccount="matRadioGroup" fxFlex
                class="button-container"
                (change)="onWSIBorBenefitsChange(haveWorkPlaceSafetyAccountText, wsibAccount.value)"
                [disabled]="loading">
                <mat-radio-button class="button-raised"
                  [ngClass]="{ active: true === haveWorkplaceSafetyAccount?.value }" [value]="true"
                  data-test="wsib-account-yes">Yes</mat-radio-button>
                <mat-radio-button class="button-raised"
                  [ngClass]="{ active: false === haveWorkplaceSafetyAccount?.value }" [value]="false"
                  data-test="wsib-account-no">No</mat-radio-button>
              </mat-radio-group>
            </div>
            @if (haveWorkplaceSafetyAccount?.touched && haveWorkplaceSafetyAccount?.invalid) {
            <mat-error>
              {{ getHaveWorkplaceSafetyAccountErrorMessage() }}
            </mat-error>
            }
            <!-- Upload WSIB -->
            @if (haveWorkplaceSafetyAccount?.value) {
            <div [ngClass]="{ 'invalid-section ': WsibClearance?.invalid }">
              <span class="field-header">WSIB clearance *</span>
              @if (!WsibClearance?.value) {
              <div class="add-file">
                <input #WsibClearanceUpload type="file" [accept]="acceptTypes"
                  (change)="onFileChange(WsibClearanceUpload, wsibClearanceText)" [hidden]="true"
                  data-test="wsib-clearance-file" />
                <div class="add-file-content" (click)="WsibClearanceUpload.click()" data-test="btn-wsib-clearance-file">
                  <mat-icon svgIcon="upload-file-tree" class="icon-color"></mat-icon>&nbsp;Upload now
                </div>
              </div>
              } @else {
              <div class="added-file">
                <div class="added-icon" (click)="viewDocument(wsibClearanceText)">
                  <div class="added-display-icon">
                    <mat-icon svgIcon="icon-file-blue" class="added-icon-color"></mat-icon>
                  </div>
                  <div class="file-name" data-test="uploaded-file-name">
                    <p>
                      {{
                      !loading
                      ? WsibClearance?.value?.name
                      ? WsibClearance?.value?.name
                      : 'WSIB clearance'
                      : 'Uploading...'
                      }}
                    </p>
                  </div>
                </div>
                <div class="delete-icon" (click)="deleteDocuments(wsibClearanceText)"
                  data-test="wsib-clearance-file-delete">
                  <mat-icon svgIcon="delete-icon"></mat-icon>
                </div>
              </div>
              }
            </div>
            }
          </div>
        </div>
      </div>

      <!-- Disability Benefits Card -->
      <div class="section-card">
        <div class="section-header">
          <p>Disability Benefits</p>
        </div>
        <div class="card-content">
          <div class="field-row">
            <div>
              <span class="field-header">Do you have an alternate Disability benefit?</span>
            </div>
            <div>
              <mat-radio-group formControlName="haveDisabilityBenefit" #disabilityBenefit="matRadioGroup" fxFlex
                class="button-container"
                (change)="onWSIBorBenefitsChange(haveDisabilityBenefitText, disabilityBenefit.value)"
                [disabled]="loading">
                <mat-radio-button class="button-raised" [ngClass]="{ active: true === haveDisabilityBenefit?.value }"
                  [value]="true" data-test="disability-benefit-yes">Yes</mat-radio-button>
                <mat-radio-button class="button-raised" [ngClass]="{ active: false === haveDisabilityBenefit?.value }"
                  [value]="false" data-test="disability-benefit-no">No</mat-radio-button>
              </mat-radio-group>
            </div>
            @if (haveDisabilityBenefit?.touched && haveDisabilityBenefit?.invalid) {
            <mat-error>
              {{ getHaveDisabilityBenefitErrorMessage() }}
            </mat-error>
            }
            @if (haveDisabilityBenefit?.value) {
            <div>
              <!-- Upload Proof of Insurance -->
              <div class="margin-top-md" [ngClass]="{ 'invalid-section ': DisabilityBenefitProofInsurance?.invalid }">
                <span class="field-header">Proof of Insurance *</span>
                @if (!DisabilityBenefitProofInsurance?.value) {
                <div class="add-file">
                  <input #disabilityBenefitProofInsuranceUpload type="file" [accept]="acceptTypes"
                    (change)="onFileChange(disabilityBenefitProofInsuranceUpload, disabilityBenefitProofInsuranceText)"
                    [hidden]="true" data-test="insurance-file" />
                  <div class="add-file-content" (click)="disabilityBenefitProofInsuranceUpload.click()"
                    data-test="btn-insurance-file">
                    <mat-icon svgIcon="upload-file-tree" class="icon-color"></mat-icon>&nbsp;Upload now
                  </div>
                </div>
                } @else {
                <div class="added-file">
                  <div class="added-icon" [ngClass]="isCreateMode ? 'no-cursor' : ''"
                    (click)="viewDocument(disabilityBenefitProofInsuranceText)">
                    <div class="added-display-icon">
                      <mat-icon svgIcon="icon-file-blue" class="added-icon-color"></mat-icon>
                    </div>
                    <div class="file-name" data-test="uploaded-file-name">
                      <p>
                        {{
                        !loading
                        ? DisabilityBenefitProofInsurance?.value?.name
                        ? DisabilityBenefitProofInsurance?.value?.name
                        : 'Proof of Insurance'
                        : 'Uploading...'
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="delete-icon" (click)="deleteDocuments(disabilityBenefitProofInsuranceText)"
                    data-test="insurance-file-delete">
                    <mat-icon svgIcon="delete-icon"></mat-icon>
                  </div>
                </div>
                }
              </div>
              <!-- Upload Policy Document -->
              <div class="margin-top-md" [ngClass]="{ 'invalid-section ': DisabilityBenefitPolicyDocument?.invalid }">
                <span class="field-header">Policy Document *</span>
                @if (!DisabilityBenefitPolicyDocument?.value) {
                <div class="add-file">
                  <input #disabilityBenefitPolicyDocumentUpload type="file" [accept]="acceptTypes"
                    (change)="onFileChange(disabilityBenefitPolicyDocumentUpload, disabilityBenefitPolicyDocumentText)"
                    [hidden]="true" data-test="policy-file" />
                  <div class="add-file-content" (click)="disabilityBenefitPolicyDocumentUpload.click()"
                    data-test="btn-policy-file">
                    <mat-icon svgIcon="upload-file-tree" class="icon-color"></mat-icon>&nbsp;Upload now
                  </div>
                </div>
                } @else {
                <div class="added-file">
                  <div class="added-icon" (click)="viewDocument(disabilityBenefitPolicyDocumentText)">
                    <div class="added-display-icon">
                      <mat-icon svgIcon="icon-file-blue" class="added-icon-color"></mat-icon>
                    </div>
                    <div class="file-name" data-test="uploaded-file-name">
                      <p>
                        {{
                        !loading
                        ? DisabilityBenefitPolicyDocument?.value?.name
                        ? DisabilityBenefitPolicyDocument?.value?.name
                        : 'Policy Document'
                        : 'Uploading....'
                        }}
                      </p>
                    </div>
                  </div>
                  <div class="delete-icon" (click)="deleteDocuments(disabilityBenefitPolicyDocumentText)"
                    data-test="policy-file-delete">
                    <mat-icon svgIcon="delete-icon"></mat-icon>
                  </div>
                </div>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </form>
</div>
}